import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from '../lib/i18n';
import './SigningOutOverlay.css';

/**
 * Full-screen overlay shown while signOut() is in progress.
 *
 * Blocks user interaction during forceSync + clearAllData (typically 1-3s
 * online, up to ~15s in bad-network edge cases). Without this overlay users
 * would see the logout button "do nothing" for a noticeable delay and might
 * click it again or try to navigate away mid-sync, causing data loss.
 *
 * Mounted at App.jsx top level (sibling of AccountSwitchDialog) so it
 * survives route changes — AppLayout unmounts when signOut clears `user`
 * and ProtectedRoute redirects to /auth.
 */
export default function SigningOutOverlay() {
  const { signingOut } = useAuth();
  const { t } = useTranslation();
  if (!signingOut) return null;
  return (
    <div className="signout-overlay" role="alert" aria-busy="true">
      <div className="signout-modal">
        <div className="signout-spinner" aria-hidden>
          <div className="signout-spinner-ring" />
        </div>
        <h2 className="signout-title">{t('signOut.title') || 'Signing out…'}</h2>
        <p className="signout-message">{t('signOut.message') || 'Saving your unsynced changes'}</p>
        <p className="signout-hint">{t('signOut.hint') || 'Please wait a moment'}</p>
      </div>
    </div>
  );
}
